import { render, staticRenderFns } from "./DailySentence.vue?vue&type=template&id=35be6e5b&scoped=true"
import script from "./DailySentence.vue?vue&type=script&lang=js"
export * from "./DailySentence.vue?vue&type=script&lang=js"
import style0 from "./DailySentence.vue?vue&type=style&index=0&id=35be6e5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35be6e5b",
  null
  
)

export default component.exports